<div
  class="mb-6"
  [class]="
    isTemplate()
      ? 'w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700'
      : ''
  "
>
  @if(editable()){
  <label
    [for]="uiId"
    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
  >
    @if(isTemplate()){
    <h5 class="mb-2 text-3xl font-bold text-gray-900 dark:text-white">
      Altere a lista de opções disponíveis
    </h5>
    } @else{
    {{ placeHolder() }}{{ required() ? "*" : "" }}
    }
  </label>
  @if(isTemplate()){ @let defaultChoice = choiceList().concat('');
  <div class="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <ui-text
      placeHolder="Nome ou pergunta da lista."
      [value]="placeHolder()"
      [editable]="true"
      (valueChange)="onPlaceholderChange($event)"
    />
    <ui-list
      placeHolder="Escolha o tipo do campo"
      [value]="type()"
      [choice]="listTypes"
      [editable]="true"
      (valueChange)="onTypeChange($event)"
    />
    <ui-text
      placeHolder="Lista de escolhas (Uma por linha)"
      [value]="choiceList().join('\n')"
      [type]="Types.EInput.AREA"
      [editable]="true"
      (valueChange)="onChoiceChange($event)"
    />
    <ui-list
      placeHolder="Escolha padrão"
      [value]="default()"
      [choice]="defaultChoice"
      [editable]="true"
      [type]="type()"
      (valueChange)="onDefaultChange($event)"
    />
  </div>
  } @else{ @switch(type()){ @case (Types.EList.RADIOBOX) {
  <div [id]="uiId">
    <div
      class="flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700"
      *ngFor="let item of choiceList(); index as i"
    >
      <input
        [checked]="isChecked(item, value())"
        id="bordered-radio-{{ uiId }}-{{ i }}"
        type="radio"
        value=""
        (click)="onValueChange(item)"
        name="bordered-radio-{{ uiId }}-{{ i }}"
        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
      />
      <label
        for="bordered-radio-{{ uiId }}-{{ i }}"
        class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
        >{{ getName(item) }}</label
      >
    </div>
  </div>
  } @case (Types.EList.CHECKBOX) {
  <div [id]="uiId">
    <div
      class="flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700"
      *ngFor="let item of choice(); index as i"
    >
      <input
        [checked]="hasMember(value(), item)"
        id="bordered-checkbox-{{ uiId }}-{{ i }}"
        type="checkbox"
        value=""
        (change)="onValueChange(getId(item), $event.target)"
        name="bordered-checkbox-{{ uiId }}-{{ i }}"
        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
      />
      <label
        for="bordered-checkbox-{{ uiId }}-{{ i }}"
        class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
        >{{ getName(item) }}</label
      >
    </div>
  </div>
  } @default {
  <select
    [id]="uiId"
    (change)="onValueSelected($event.target)"
    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  >
    <option [selected]="!value()">Escolha uma das opções disponíveis</option>
    <option
      *ngFor="let item of choice(); index as i"
      [value]="getId(item)"
      [selected]="isChecked(item, value())"
    >
      {{ getName(item) }}
    </option>
  </select>
  } } } }@else{
  <span class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
    ><b>{{ placeHolder() }}:</b> {{ getName(value()) }}</span
  >
  }
</div>
